import { Data } from '@blade/std-lib'

import type { AtomMut } from '@reatom/framework'

export class ResourceRegistryItemReady<T> extends Data.TaggedClass('Ready')<{
  entityAtom: AtomMut<T>
}> {}

export class ResourceRegistryItemSubscribed<T> extends Data.TaggedClass(
  'Subscribed',
)<{ entityAtom: AtomMut<T> }> {}

export type ResourceRegistryItem<T> =
  | ResourceRegistryItemReady<T>
  | ResourceRegistryItemSubscribed<T>
